import React, { useEffect, useRef } from "react";
import { PiCheckBold } from "react-icons/pi";
import { isActRemovedByAction } from "../../utils";
import { usePrescriptionHover } from "../PrescriptionHoverContext";

const ActChip = ({ act, hiddenCodes, onClick, isActive = false, doneLabel }) => {
  const { onCodeHover, onCodeUnhover, registerCodeElement } = usePrescriptionHover();
  const chipRef = useRef(null);

  useEffect(() => {
    const element = chipRef.current;
    if (!element) return;
    return registerCodeElement(act._id, element);
  }, [act._id, registerCodeElement]);

  const codes = act.isDeleted || isActRemovedByAction(act) ? act.codesPredicted : act.codes;
  const isHidden = codes.length > 0 && codes.every((code) => hiddenCodes.has(code));

  const colorClass = isHidden
    ? "border-gray-200 bg-gray-50 text-gray-500"
    : act.codes.length > 0 && act.codesPredicted.length === 0
      ? "border-yellow-200 bg-yellow-50 text-yellow-800"
      : act.isDeleted && act.codesPredicted.length !== 0
        ? "border-red-200 bg-red-50 text-red-700"
        : isActRemovedByAction(act)
          ? "border-red-200 bg-[repeating-linear-gradient(45deg,#ef444426_0_2px,transparent_2px_8px)] text-red-700"
          : act.codesPredicted.length === 0
            ? "border-orange-200 bg-orange-50 text-orange-700"
            : act.notInserted && act.codesPredicted.length !== 0
              ? "border-primary-200 bg-primary-50 text-primary-700"
              : act.ALD
                ? "border-purple-200 bg-purple-50 text-purple-700"
                : "border-green-200 bg-green-50 text-green-700";

  const Element = onClick ? "button" : "span";

  return (
    <Element
      ref={chipRef}
      type={onClick ? "button" : undefined}
      onClick={onClick}
      className={`inline-flex max-w-full items-center gap-1.5 rounded-md border px-2 py-0.5 text-xs font-medium ${colorClass} ${
        onClick ? "cursor-pointer transition-shadow hover:shadow-sm focus:outline-none focus:ring-2 focus:ring-primary-500/30" : ""
      } ${isActive ? "ring-2 ring-primary-500/40" : ""}`}
      onMouseEnter={() => onCodeHover(act._id)}
      onMouseLeave={() => onCodeUnhover(act._id)}
      title={doneLabel || (isHidden ? "Code masqué : ne compte pas comme correction" : undefined)}
    >
      {doneLabel && <PiCheckBold className="h-3 w-3 shrink-0" />}
      <span className="truncate">{act.text || "N/A"}</span>
      <span className="opacity-40">·</span>
      <span className={`shrink-0 font-mono${isActRemovedByAction(act) ? " line-through opacity-60" : ""}`}>{codes.join(", ") || "N/A"}</span>
    </Element>
  );
};

export default ActChip;
